import { type ChangeEvent, type FC, type ReactNode } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';

import { Input } from 'dibs-elements/exports/Input.tsx';

import fieldNames from '../../data/sellerApplicationFieldNames.json' with { type: 'json' };

const messages = defineMessages({
    zipCode: {
        id: 'DealerApplicationForm.ZipCode.placeholder',
        defaultMessage: 'Zip Code',
    },
});

type Props = {
    errorMessage: ReactNode;
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
};

const ZipCode: FC<Props> = ({ errorMessage, disabled, value, onChange }) => {
    const intl = useIntl();
    return (
        <Input
            placeholder={intl.formatMessage(messages.zipCode)}
            hasAnimatedPlaceholder
            autoComplete="postal-code"
            dataTn="dealer-zip-code"
            name={fieldNames.dealerInfo.zipCode}
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={disabled}
            value={value}
        />
    );
};

export default ZipCode;
